export { default as WidgetManager } from './WidgetManager'
export * from './WidgetManager.types'
